import React, { Component } from 'react';
import './Specification.css';
import Urls from '../urls/Urls';
import IconButton from './IconButton';
import HashSource from '../core/HashSource';
import ParameterErrors from '../errors/ParameterErrors';
const{throwNotProvided}=ParameterErrors;
export default class Specification extends Component{
	constructor(props){
		super(props);
		const{hide, getInsertedMenuItemsHandler, configuration}=props;
		this._configuration = configuration;
		if(!getInsertedMenuItemsHandler)throwNotProvided('getInsertedMenuItemsHandler');
		this._callbackHide = hide;
		this._handleClickButtonBack = this._handleClickButtonBack.bind(this);
		this._getInsertedMenuItemsHandler = getInsertedMenuItemsHandler;
		this.state = {visible:false};
	}
	componentDidMount(){
		
	}
	setVisible(value){
		console.log('CALLED IT');
		console.log(value);
		this._insertedMenuItemsRemoveHandle?.dispose();
		this._insertedMenuItemsRemoveHandle = null;
		if(value){
			this._insertedMenuItemsRemoveHandle = this._getInsertedMenuItemsHandler().registerMenuItems([
					(<IconButton className="configurator-back-button" imgUrl ={Urls.assets+'icons/UI_Button_Exit.png'} onClick={this._handleClickButtonBack} key={HashSource.next()}></IconButton>)
				]
			);
		}
		this.setState({visible:value});
	}
	_handleClickButtonBack(){
		this._callbackHide();
	}
	closeCurrentConfigurator(){
	}
	render(){
		const className="specification"+(this.state.visible?" visible":"");
		return (<div className={className}>
			<div className="wrapper">
				<img src={Urls.assets+'specification.png'} key={'specification_img'} style={{height:'100%'}}></img>
			</div>
		</div>);
	}
}
